import React, { useContext, useEffect, useState } from 'react';
import { Container } from 'reactstrap';

import AppContext from '../AppContext';
import dataManager from '../DataManager';
import InfoItem from './InfoItem';
import NewItemView from './NewItemView';
import Utils from "../Utils";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt as EmptyTrash, faStar as SolidStar, faPaste as Paste } from '@fortawesome/free-solid-svg-icons';
import { faStar as RegularStar } from '@fortawesome/free-regular-svg-icons';

import contentViewStyles from './ContentView.module.css';
import styles from './PageView.module.css';

function PageView({ category }) {
  const { t, user } = useContext(AppContext);
  const [data, setData] = useState([]);
  const [expandedRecord, setExpandedRecord] = useState(null);
  const [editingTitleId, setEditingTitleId] = useState(null);
  const [editableTitle, setEditableTitle] = useState('');
  const [showStarredOnly, setShowStarredOnly] = useState(false);

  useEffect(() => {
    const handleData = (snapshot) => {
      const records = [];
      snapshot.forEach((childSnapshot) => {
        const recordId = childSnapshot.key;
        const recordData = childSnapshot.val();
        if (recordData.category === category && (!showStarredOnly || recordData.starred)) {
          records.push({ id: recordId, data: recordData });
        }
      });
      records.reverse();
      setData(records);
    };

    const unsubscribe = dataManager.addValueChangedListener(handleData, (error) => {
      console.error('Error getting documents:', error);
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [user, category, showStarredOnly]);

  const emptyTrash = () => {
    if (window.confirm('Are you sure you want to empty the trash?')) {
      dataManager.emptyTrash();
    }
  };

  const toggleStarFilter = () => {
    setShowStarredOnly(!showStarredOnly);
  }

  const paste = async () => {
    const { type, value } = await Utils.getClipboardContent();
    // console.log("pasting:", type, ";value=", value);
    if (type === 'Image') {
      // TODO: support image
      alert(t('message.imageNotSupported'));
      return;
    }
    const record ={ type, title: "", content: value, category };
    // TODO: find duplicated record
    console.log("saving:", record);
    await dataManager.createRecord(record);
  }

  const addItem = async (title, content) => {
    const record = { title, content, category, type: 'Text' };
    console.log("adding new item:", record);
    await dataManager.createRecord(record);
  }

  const InfoItems = ({ pinned }) => {
    const filteredRecords = data.filter((record) => !!record.data.pinned === pinned);
    if (filteredRecords.length === 0) {
      return null;
    }
    return (
      <div className={styles[pinned ? "pinnedArea" : "unpinnedArea"]}>
        { filteredRecords
          .map((record) => (
            <InfoItem
              key={record.id}
              record={record}
              states={{
                expandedRecord, setExpandedRecord,
                editingTitleId, setEditingTitleId,
                editableTitle, setEditableTitle,
              }}
            />
          ))}
      </div>
    );
  };

  return (
    <Container className={contentViewStyles.pageContent}>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className={`my-4 ${contentViewStyles.title}`} >{t(`title.${category}`)} ({data.length})</h1>
        <div className="d-flex justify-content-end mb-2">
          {category !== 'Trash' && (
            <div className={`${contentViewStyles.iconWrapper} ${contentViewStyles.disabledIconWrapper}`} onClick={paste}>
              <FontAwesomeIcon className={contentViewStyles.commandIcon}
                icon={Paste} title={t('command.paste')}
              />
            </div>
          )}
          <div className={contentViewStyles[showStarredOnly ? 'iconWrapper' : 'disabledIconWrapper']} onClick={toggleStarFilter}>
            <FontAwesomeIcon className={contentViewStyles.commandIcon}
              icon={showStarredOnly ? SolidStar : RegularStar} title={t('command.show' + (showStarredOnly ? "All" : "StarredOnly"))}
            />
          </div>
          {category === 'Trash' ? (
            <div className={`${contentViewStyles.danger} ${contentViewStyles[data.length > 0 ? 'iconWrapper' : 'disabledIconWrapper']}`}
              onClick={data.length > 0 ? emptyTrash : undefined}>
              <FontAwesomeIcon className={contentViewStyles.commandIcon}
                icon={EmptyTrash} title={t('command.emptyTrash')}
              />
            </div>
          ) : (
              <div>
                <NewItemView addItem={addItem}
                  className={contentViewStyles.disabledIconWrapper}
                  iconClassName={contentViewStyles.commandIcon}
                  maxTitleLength={dataManager.getSetting().titleCharacterLimit}
                  maxContentLength={dataManager.getSetting().contentCharacterLimit}
                />
              </div>
          )}
        </div>
      </div>

      <InfoItems pinned={true} />
      <InfoItems pinned={false} />
    </Container>
  );
}

export default PageView;
